// extracted by mini-css-extract-plugin
export var brand = "_8r-9";
export var compact = "_8r-6";
export var extraSmall = "_8r-7";
export var icon = "_8r-0";
export var large = "_8r-4";
export var light = "_8r-1";
export var medium = "_8r-5";
export var outline = "_8r-b";
export var primaryDark = "_8r-a";
export var primaryLight = "_8r-8";
export var primaryModern = "_8r-c";
export var success = "_8r-2";
export var successSolid = "_8r-3";